module.exports = __webpack_public_path__ + "media/src/images/favicons/favicon-196x196-a071de4359b4663885a13b63841c77de.png";